/* Süti sticky add-to-cart bar.

   REWRITTEN because the previous version was starving the page. It ran a
   MutationObserver over all of #MainContent whose callback wrote back into
   #MainContent (retriggering itself every frame), a setInterval every 800ms
   doing full querySelectorAll sweeps, and a burst() firing seven more of those
   after any click anywhere. The Kaching branch also called .click() on the
   bundle widget's comboboxes to read their options — and since that widget is
   now hidden by CSS but still in the DOM, it ran blind, on a loop.

   Measured effect on the live PDP: the hero image took 25 SECONDS to change
   after a colour selection; after these changes, 11s. The remaining delay is
   the page itself (3.4MB per variant change) and is handled separately by
   suti-sticky-atc-hero.js.

   Now: syncing is event-driven, the observer is scoped to the product form and
   disconnects while writing, scroll only toggles visibility, and the bundle
   branch is gone.

   TWO PILLS, TWO ROWS. Model and finish get a pill each on the top row and the
   buy button spans the row beneath. One combined pill fitted beside the button
   but truncated the finish name to nothing readable — "Maranello Red NanoLeather"
   is most of the catalogue's naming. The model pill is sized to its content and
   the finish pill takes the rest, because model names are short and finish names
   are not.

   BOTH LISTS SHOW EVERYTHING, with what is not made for the current model struck
   through. Filtering the finishes down to the available ones looked tidier until
   the model became changeable from this bar: switch to a model the current
   finish is not made for and the checked input is an unavailable one, so it fell
   out of the filtered list, nothing was checked, and the finish pill vanished
   mid-session. Showing the whole range also answers "can I get this in 15 Pro
   Max" rather than silently hiding the answer.

   THE ONE EXCEPTION IS A FINISH THAT HAS NOT LAUNCHED — see hiddenFinishes
   below. "Everything, with the unavailable struck through" is a promise about
   the range on sale; a finish that is not announced yet is not part of it.

   THE BUTTON MIRRORS THE REAL ONE, words and disabled state both. Changing the
   model from this bar can land on a combination that does not exist — Maranello
   Red NanoLeather is not made for 15 Pro Max — and the theme's own button then
   reads "Unavailable" with no price. Left to itself the sticky bar went on
   offering "Add to cart · $49" for it, with the price left over from the last
   variant that did exist: an enabled buy button for something unbuyable, at a
   price that was not even its own.

   Picking an option closes its menu. Leaving one open through a variant change
   would mean holding selected-state over a page that re-renders itself
   underneath — the exact thing that caused the earlier picker desync here.
*/
(() => {
  const bar = document.getElementById('suti-sticky-atc');
  if (!bar) return;

  const main = document.getElementById('MainContent') || document.body;
  const priceOut = bar.querySelector('[data-sticky-price]');
  const metaOut = bar.querySelector('[data-sticky-variant]');
  const titleOut = bar.querySelector('[data-sticky-title]');
  const ratingOut = bar.querySelector('[data-sticky-rating]');
  const imgOut = bar.querySelector('[data-sticky-image]');
  const addBtn = bar.querySelector('[data-sticky-add]');
  const addLabel = bar.querySelector('.suti-sticky-atc__button-text');
  const addDivider = bar.querySelector('.suti-sticky-atc__button-divider');
  const pickersWrap = bar.querySelector('[data-sticky-pickers]');

  const images = window.sutiStickyVariantImages || {};
  const colourImages = window.sutiStickyColourImages || {};
  const productTitle = window.sutiStickyProductTitle || (titleOut ? titleOut.textContent : '');

  /* UNLAUNCHED FINISHES. The list comes from
     snippets/suti-hidden-finishes.liquid by way of layout/theme.liquid; see that
     snippet for why one list serves three surfaces.

     This bar reads the THEME's variant-picker, which carries every variant on
     the product. That picker is not the one on screen — the visible picker is
     the swatch app's, and the app is what hides unlaunched finishes from it — so
     everything the app was hiding came straight back out in this menu. */
  const hiddenFinishes = (window.sutiHiddenFinishes || [])
    .map((term) => String(term).trim())
    .filter((term) => term.length > 0);

  const isHiddenFinish = (name) =>
    hiddenFinishes.length > 0 && !!name && hiddenFinishes.some((term) => name.indexOf(term) !== -1);

  const text = (el) => (el && el.textContent ? el.textContent.trim() : '');
  const getRealBtn = () => main.querySelector('product-form-component .add-to-cart-button');
  const tidyPrice = (v) => (v || '').replace(/([.,])00(\D*)$/, '$2');
  const setText = (el, v) => { if (el && v && el.textContent !== v) el.textContent = v; };

  /* The real button's own words, minus the price this script injects into it. */
  const realLabel = (btn) => {
    const label = btn && btn.querySelector('.add-to-cart-text');
    if (!label) return '';
    const copy = label.cloneNode(true);
    copy.querySelectorAll('[data-suti-atc-price], .suti-atc-divider').forEach((el) => el.remove());
    return copy.textContent.replace(/\s+/g, ' ').trim();
  };

  /* ---------- iOS Chrome: keep the bar on the visible edge ----------
     bottom:0 anchors to the layout viewport, which on iOS Chrome is taller than
     the visible area — so the bar parks under the browser toolbar and leaves a
     strip of page showing beneath it. This measures the difference; it is 0
     everywhere else. */
  const vv = window.visualViewport;
  let vvQueued = false;
  const syncViewport = () => {
    vvQueued = false;
    if (!vv) return;
    const gap = Math.max(0, Math.round(
      document.documentElement.clientHeight - (vv.height + vv.offsetTop)
    ));
    bar.style.setProperty('--suti-vv-bottom', gap + 'px');
  };
  const queueViewport = () => {
    if (vvQueued) return;
    vvQueued = true;
    requestAnimationFrame(syncViewport);
  };
  if (vv) {
    vv.addEventListener('resize', queueViewport, { passive: true });
    vv.addEventListener('scroll', queueViewport, { passive: true });
    syncViewport();
  }

  /* ---------- price mirrored onto the theme's own button ---------- */
  let formObserver = null;
  let observedForm = null;

  const stopObserving = () => { if (formObserver) formObserver.disconnect(); };
  const startObserving = () => {
    if (formObserver && observedForm && observedForm.isConnected) {
      formObserver.observe(observedForm, { childList: true, subtree: true });
    }
  };

  let lastPrice = '';
  const decorateMain = (priceText) => {
    lastPrice = priceText || '';
    const btn = getRealBtn();
    if (!btn) return;
    const label = btn.querySelector('.add-to-cart-text');
    if (!label) return;

    stopObserving();
    btn.classList.add('suti-atc-main');
    let price = label.querySelector('[data-suti-atc-price]');
    let divider = label.querySelector('.suti-atc-divider');
    if (!price) {
      divider = document.createElement('span');
      divider.className = 'suti-atc-divider';
      divider.setAttribute('aria-hidden', 'true');
      price = document.createElement('span');
      price.className = 'suti-atc-price';
      price.setAttribute('data-suti-atc-price', '');
      label.append(divider, price);
    }
    /* No price means no sellable variant is selected — leaving the last one in
       place would price an "Unavailable" button. */
    if (price.textContent !== lastPrice) price.textContent = lastPrice;
    if (divider) divider.hidden = !lastPrice;
    startObserving();
  };

  /* ---------- rating ---------- */
  let ratingSignature = '';
  const syncRating = () => {
    const source = main.querySelector('.rating-wrapper');
    if (!source || !ratingOut) return;
    const signature = source.textContent.replace(/\s+/g, ' ').trim();
    if (!signature || signature === ratingSignature) return;
    ratingSignature = signature;
    ratingOut.innerHTML = '';
    const clone = source.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    ratingOut.appendChild(clone);
  };

  /* ---------- bar thumbnail ---------- */
  const setImage = (src) => {
    if (!imgOut || !src) return;
    const next = new URL(src, window.location.origin).href;
    if (imgOut.src === next || imgOut.dataset.pending === next) return;
    imgOut.dataset.pending = next;
    imgOut.classList.add('is-swapping');
    const pre = new Image();
    const done = () => { imgOut.classList.remove('is-swapping'); delete imgOut.dataset.pending; };
    pre.onload = () => { imgOut.src = next; done(); };
    pre.onerror = done;
    pre.src = next;
  };

  /* ---------- the two option sets ---------- */

  /* Every colour input, available or not — see the header note — except the
     finishes that have not launched.

     FILTERED HERE, AT THE ONE READER. Both the pill's label and the menu's
     options come through this function, so dropping them here is enough: there
     is no second list to keep in step, and nothing unlaunched reaches the DOM to
     be found by a keyboard or a find-in-page. */
  const colourInputs = () => {
    const fieldsets = [...main.querySelectorAll('variant-picker fieldset')];
    const target = fieldsets.find((f) => /colou?r/i.test(text(f.querySelector('legend'))));
    const scope = target || fieldsets[fieldsets.length - 1];
    if (!scope) return [];
    return [...scope.querySelectorAll('input')].filter((input) => !isHiddenFinish(input.value));
  };

  const unavailable = (input) => input.dataset.optionAvailable === 'false';

  /* The model is a native select in this theme, not a swatch set. */
  const modelSelect = () => main.querySelector('variant-picker select');
  const shortModel = (v) => (v || '').replace(/^\s*iPhone\s+/i, '');

  const currentVariantId = () => {
    const input = main.querySelector('product-form-component form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? String(input.value) : '';
  };

  /* ---------- picker UI ---------- */
  let openMenu = null;
  const closeMenus = () => {
    if (!openMenu) return;
    openMenu.menu.hidden = true;
    openMenu.picker.classList.remove('is-open');
    openMenu.toggle.setAttribute('aria-expanded', 'false');
    openMenu = null;
  };

  const setSwatch = (el, src) => {
    if (!el) return;
    const next = src ? 'url("' + src + '")' : 'none';
    if (el.style.backgroundImage !== next) el.style.backgroundImage = next;
  };

  const buildPicker = ({ kind, ariaLabel, label, swatch, options, onSelect }) => {
    const picker = document.createElement('div');
    picker.className = 'suti-sticky-atc__picker suti-sticky-atc__picker--' + kind;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'suti-sticky-atc__picker-button';
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', ariaLabel);

    if (swatch !== undefined) {
      const dot = document.createElement('span');
      dot.className = 'suti-sticky-atc__picker-swatch';
      setSwatch(dot, swatch);
      toggle.appendChild(dot);
    }

    const name = document.createElement('span');
    name.className = 'suti-sticky-atc__picker-label';
    name.textContent = label;
    toggle.appendChild(name);

    toggle.insertAdjacentHTML('beforeend', '<svg class="suti-sticky-atc__chevron" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 5L5 1l4 4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>');

    const menu = document.createElement('div');
    menu.className = 'suti-sticky-atc__menu';
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', ariaLabel);
    menu.hidden = true;

    options.forEach((opt) => {
      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'suti-sticky-atc__option';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      if (opt.disabled) {
        option.disabled = true;
        option.classList.add('is-unavailable');
      }

      if (opt.swatch !== undefined) {
        const dot = document.createElement('span');
        dot.className = 'suti-sticky-atc__option-swatch';
        setSwatch(dot, opt.swatch);
        option.appendChild(dot);
      }

      const optionName = document.createElement('span');
      optionName.textContent = opt.label;
      option.appendChild(optionName);

      option.addEventListener('click', (event) => {
        event.stopPropagation();
        closeMenus();
        onSelect(opt.value);
      });
      menu.appendChild(option);
    });

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = openMenu && openMenu.menu === menu;
      closeMenus();
      if (isOpen) return;
      menu.hidden = false;
      picker.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      openMenu = { menu, picker, toggle };
    });

    picker.append(toggle, menu);
    return picker;
  };

  let pickerSignature = '';
  const renderPickers = () => {
    if (openMenu) return;

    const inputs = colourInputs();
    /* Fall back to the first input so the pill still renders while the theme is
       mid-rerender and nothing is checked yet. A deep link straight to an
       unlaunched variant lands here too: that finish is not in the list, so the
       pill names the first launched one rather than announcing it. */
    const checked = inputs.find((i) => i.checked) || inputs[0];
    const sel = modelSelect();
    const model = sel ? sel.value : '';

    const signature = (checked ? checked.value : '') + '|' + inputs.length + '|' + model;
    if (signature === pickerSignature) return;
    pickerSignature = signature;

    pickersWrap.innerHTML = '';

    if (sel) {
      pickersWrap.appendChild(buildPicker({
        kind: 'model',
        ariaLabel: 'Your iPhone: ' + model,
        /* Short, because every option starts with the same word. */
        label: shortModel(model),
        options: [...sel.options].map((o) => ({
          value: o.value,
          label: o.textContent.trim(),
          selected: o.value === model,
          disabled: o.disabled
        })),
        onSelect: (next) => {
          const fresh = modelSelect();
          if (!fresh || fresh.value === next) return;
          fresh.value = next;
          fresh.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }));
    }

    if (checked) {
      pickersWrap.appendChild(buildPicker({
        kind: 'colour',
        ariaLabel: 'Finish: ' + checked.value,
        label: checked.value,
        swatch: colourImages[checked.value],
        options: inputs.map((i) => ({
          value: i.value,
          label: i.value,
          selected: i.checked,
          disabled: unavailable(i),
          swatch: colourImages[i.value]
        })),
        onSelect: (next) => {
          const fresh = colourInputs().find((i) => i.value === next);
          if (!fresh || fresh.checked) return;
          /* Clicking the real input drives price, legend, form and URL; the hero
             image is handled by suti-sticky-atc-hero.js, which listens for this
             same change event. The colour lab listens too, so its chips follow. */
          fresh.click();
        }
      }));
    }
  };

  /* ---------- one sync pass ---------- */
  const syncContent = () => {
    syncRating();
    renderPickers();

    const value = tidyPrice(text(main.querySelector('product-price .price')));
    setText(titleOut, productTitle);
    const sizeSelect = modelSelect();
    setText(metaOut, sizeSelect && sizeSelect.value ? sizeSelect.value : '');
    setImage(images[currentVariantId()]);

    /* Price is assigned rather than setText'd: '' has to be able to clear it. */
    if (priceOut && priceOut.textContent !== value) priceOut.textContent = value;
    if (addDivider) addDivider.hidden = !value;

    const btn = getRealBtn();
    setText(addLabel, realLabel(btn));
    const blocked = !!btn && btn.disabled;
    if (addBtn.disabled !== blocked) addBtn.disabled = blocked;

    decorateMain(value);
  };

  let syncTimer = null;
  const scheduleSync = (delay) => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncContent, delay == null ? 120 : delay);
  };

  /* ---------- visibility (scroll only — no content work here) ---------- */
  const drawerOpen = () => !!document.querySelector('dialog[open].cart-drawer__dialog, dialog[open].dialog-modal');

  /* The bar appears the moment the theme's own Add to cart scrolls off the top,
     and stays for the rest of the page.

     It used to wait for the colour lab instead, on the reasoning that while the
     lab is on screen the shopper already has a full-size Add to cart in front of
     them and a second floating one is noise. That reasoning still holds for the
     lab itself, but it cost the entire stretch between the buy button and the
     lab — most of the page — with no buy button on screen at all. Asked for and
     agreed: the earlier trigger, with the overlap over the lab as the price.

     ONE WRITER ONLY. A first attempt put this in a second script that toggled
     the same class on its own scroll handler. Both ran, and through that middle
     stretch one said show while the other said hide — a race whose outcome was
     whichever handler fired last, i.e. a flicker. The gate belongs here, in the
     function that owns the class. */
  const gate = () => getRealBtn();

  let ticking = false;
  const updateVisibility = () => {
    ticking = false;
    const ref = gate();
    const show = !!ref && ref.getBoundingClientRect().bottom < 0 && !drawerOpen();
    if (!show) closeMenus();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateVisibility);
  };

  const attachObserver = () => {
    const form = main.querySelector('product-form-component');
    if (!form || form === observedForm) return;
    stopObserving();
    observedForm = form;
    if (!formObserver) formObserver = new MutationObserver(() => scheduleSync(150));
    startObserving();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { onScroll(); queueViewport(); }, { passive: true });

  main.addEventListener('change', () => {
    scheduleSync(150);
    setTimeout(() => { attachObserver(); syncContent(); }, 700);
  });

  document.addEventListener('click', (event) => {
    if (!bar.contains(event.target)) closeMenus();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });

  addBtn.addEventListener('click', () => {
    const btn = getRealBtn();
    if (btn) btn.click();
    scheduleSync(400);
  });

  attachObserver();
  updateVisibility();
  syncContent();
})();
